import { render, staticRenderFns } from "./MonsterLeads.vue?vue&type=template&id=1ddabf72&"
import script from "./MonsterLeads.vue?vue&type=script&lang=js&"
export * from "./MonsterLeads.vue?vue&type=script&lang=js&"
import style0 from "./MonsterLeads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports